import { isNaN } from 'lodash'

const preventNonNumber = (ev) => {
  if (/^[0-9.]$/.test(ev.key)
    || ev.key === 'Backspace'
    || ev.key === 'Tab'
  ) {
    return;
  }

  ev.preventDefault();
};

const preventNonNumberDecimal = (ev) => {
  const isDot = ev.key === '.';
  const isAllowedKey = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(ev.key);

  // Allow digits, backspace, tab, arrow keys
  const isDigit = /^[0-9]$/.test(ev.key)
  if (isDigit || isAllowedKey) {
    return;
  }

  // Allow only one dot
  if (isDot && !ev.target.value.includes('.')) {
    return;
  }

  // Prevent everything else
  ev.preventDefault();
};

const handleValidateAndFormatNumber = (number, fixed = 2, falsy = 0, customLogic = true) => {
  let tempValue = parseFloat(number)
  // every falsy data transformed into 'falsy' variable
  if (!isNaN(tempValue) && customLogic) {
    tempValue = Number(tempValue.toFixed(fixed))
    return `${tempValue.toLocaleString('en')}`
  }
  return falsy
}

export {
  preventNonNumber,
  preventNonNumberDecimal,
  handleValidateAndFormatNumber
};